/**
 * file config
 *
 * @author Shigq
 * @date 2021/11/18 15:21
 */
module.exports = {
	baseURL: '/',
	types: {
		image: ['jpg', 'jpeg', 'JPG', 'JPEG', 'gif', 'GIF', 'bmp', 'BMP', 'png'],
		compress: ['zip', 'rar', '7z'],
		excel: ['xls', 'xlsx', 'csv'],
		pdf: ['pdf'],
	}
}
